import { BlueprintsPage, WorkflowRunsPage, MarketplacePage } from '@/components/blueprints'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface NodeBlueprintsAndWorkflowsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function NodeBlueprintsAndWorkflowsDialog({
  open,
  onOpenChange,
}: NodeBlueprintsAndWorkflowsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[1200px] h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>Blueprints & Workflows</DialogTitle>
          <DialogDescription>
            Manage your project blueprints, workflow executions, and explore the marketplace for new templates.
          </DialogDescription>
        </DialogHeader>
        <Tabs defaultValue="blueprints" className="flex-1 flex flex-col">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="blueprints">Blueprints</TabsTrigger>
            <TabsTrigger value="workflows">Workflow Runs</TabsTrigger>
            <TabsTrigger value="marketplace">Marketplace</TabsTrigger>
          </TabsList>
          <TabsContent value="blueprints" className="flex-1 overflow-auto">
            <BlueprintsPage />
          </TabsContent>
          <TabsContent value="workflows" className="flex-1 overflow-auto">
            <WorkflowRunsPage />
          </TabsContent>
          <TabsContent value="marketplace" className="flex-1 overflow-auto">
            <MarketplacePage />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  )
}
